import React, { useEffect } from "react";
import { getUser } from "api/users";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { useTravelContext } from "misc/TravelContext";

const userRoles = {
    "admin": "Administrador",
    "driver": "Conductor",
    "client": "Cliente",
    "route_admin": "Administrador de Rutas"
};

const UserDetailsPage: React.FC = () => {
    const { user, setUser } = useTravelContext();

    useEffect(() => {
        if (!user) {
            getUser().then((fetchedUser) => {
                if (fetchedUser) {
                    setUser(fetchedUser);
                }
            });
        }
    }, [user]);

    return (
        <Box sx={{ p: 3 }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" textAlign="center"><strong>{user?.full_name}</strong></Typography>
                    <Typography variant="h6" textAlign="center">{userRoles[user?.role as keyof typeof userRoles]}</Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default UserDetailsPage;
